import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function RouteComponent() {
  return (
    <Page
      title='Reviews Settings'
      breadcrumbs={[
        {
          label: 'History',
        },
        {
          label: 'Reviews Settings',
        },
      ]}
    >
      <Container>TODO</Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/settings/reviews',
  component: RouteComponent,
  type: 'auth',
  locationRequired: true,
});
